<!-- Header -->

<np-header >
  <!-- Search -->
  <!-- <np-search [searchType]="SearchType.Global"></np-search> -->
  <!-- Global (top menu) Navigation -->
  <np-menu [location]="NavigationLocation.Global"></np-menu>
</np-header>
<!-- Site-Specific Navigation -->
<!-- <np-menu  [location]="NavigationLocation.SiteSpecific" ></np-menu> -->
<app-top-menu></app-top-menu>
<main class="container" >
    <app-loader></app-loader>
    <section id="column1">
      <app-page-header></app-page-header>
      
        <router-outlet></router-outlet>
      
    </section>
  </main>

<!-- Footer -->
<!-- [contentContactName]="'Carrie, Ho'" -->
<np-footer 
  [opcoName]="'CALAEP'"
  [opcoUrl]="'http://upstream.chevron.com/africalatinamerica/default.aspx'"
  [lastUpdate]="'February 2025'"
  [contentContactName]="'Global IT Service Desk'"
  [contentContactUrl]="'mailto:itsupport@chevron.com'" 
  [technicalContactName]="'Technical content'"
  [technicalContactUrl]="'https://go.chevron.com/CorpAffairsITHelp'" >
</np-footer>